<template>
  <modal-template :name="modalName">
    <template slot="header">
      <h2 class="h2" v-t="'modal.hkid_warning_header'"/>
    </template>
    <template slot="default">
      <p v-t="'modal.hkid_warning_body'"></p>
    </template>
    <template slot="footer">
      <button class="btn--inverted" @click="submit">{{ $t('buttons.ok_continue') }}</button>
      <button class="btn--inverted" @click="close">{{ $t('buttons.back') }}</button>
    </template>
  </modal-template>
</template>
<script>
import ModalTemplate from "@/components/modals/ModalTemplate.vue";
import { mapActions } from 'vuex';

export default {
  name: "modal-requires-id",
  components: {
    ModalTemplate
  },
  data() {
    return {
      modalName: "modal-requires-id",
    };
  },
  methods: {
    close() {
      this.$modal.hide(this.modalName);
    },
    submit() {
      this.updateLoading(true);
      this.$emit("submit");
      this.close();
    },
    ...mapActions(['updateLoading'])
  },
};
</script>
